import { render, staticRenderFns } from "./HowToPlay.vue?vue&type=template&id=3caa0f56&"
import script from "./HowToPlay.vue?vue&type=script&lang=js&"
export * from "./HowToPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports